module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.name,
    attrs: {
      "id": "layout"
    }
  }, [_c('div', {
    staticClass: "wrapper centered"
  }, [_c('div', {
    staticClass: "main-panel",
    class: {
      'loading': _vm.loading
    }
  }, [_c('div', {
    staticClass: "auth-layout-wrapper"
  }, [_c('div', {
    staticClass: "auth-header"
  }), _vm._m(0), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "auth-main-body col-md-4 col-md-offset-4 offset-md-4"
  }, [_vm._t("default")], 2)])]), _vm._m(1)]), _c('md-footer')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("images/../logo-default.svg"),
      "height": "44"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 offser-md-4 text-right"
  }, [_c('div', {
    staticClass: "logo partner"
  }, [_c('img', {
    attrs: {
      "src": require("images/../logo-default.svg"),
      "height": "25"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d83f166","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/auth.vue
// module id = EQjw
// module chunks = 13 14